export default "__VITE_ASSET__pHKfFdN7__"